export const contentLength = ['short', 'long']
